(() => {
  if (window.__vscCollectionFrames) return;
  window.__vscCollectionFrames = true;
  const bound = new WeakSet();
  function bind(frame) {
    if (bound.has(frame)) return;
    bound.add(frame);
    let observer, doc;
    const resize = () => {
      try {
        if (!frame.contentDocument?.body) return;
        const body = frame.contentDocument.body;
        const height = Math.ceil(Math.max(body.scrollHeight, body.getBoundingClientRect().height));
        if (height > 0 && height < 50000) frame.style.height = `${height}px`;
      } catch { /* The sandbox remains enforced if navigation changes origin. */ }
    };
    const loaded = () => {
      observer?.disconnect();
      doc?.removeEventListener('load', resize, true);
      doc = frame.contentDocument;
      if (!doc?.body) return;
      const font = getComputedStyle(frame.parentElement);
      doc.body.style.fontFamily = font.fontFamily;
      doc.body.style.fontSize = font.fontSize;
      doc.addEventListener('load', resize, true);
      if (typeof ResizeObserver === 'function') { observer = new ResizeObserver(resize); observer.observe(doc.body); }
      doc.fonts?.ready.then(resize);
      resize();
    };
    frame.addEventListener('load', loaded);
    if (frame.contentDocument?.readyState === 'complete') loaded();
    window.addEventListener('resize', resize);
  }
  const scan = () => document.querySelectorAll('iframe[data-vsc-collection-html]').forEach(bind);
  scan();
  document.addEventListener('DOMContentLoaded', scan, {once:true});
  document.addEventListener('shopify:section:load', scan);
})();
